import useFeatureToggles from 'utils/hooks/use-feature-toggles'
import { useUserInfo } from 'utils/hooks/use-userInfo'
import { readDeviceProfiles } from 'utils/device-profiles'

export const PROFILE_SWITCH_PATH = '/app-v2/trocar-perfil'

export const ADD_ACCOUNT_PATH = '/app-v2/login?switch_account=true'

const PROFILE_SWITCH_FLAG = 'alunotrocarperfil'

const normalizeFlagKey = (key: string) => key.replace(/[_-]/g, '').toLowerCase()

export const useProfileSwitch = () => {
  const { user } = useUserInfo()
  const { featureToggles } = useFeatureToggles()
  const isFlagOn = Object.entries(
    (featureToggles ?? {}) as Record<string, unknown>
  ).some(
    ([key, value]) =>
      value === true && normalizeFlagKey(key) === PROFILE_SWITCH_FLAG
  )

  const hasOtherDeviceProfiles =
    typeof window !== 'undefined' && readDeviceProfiles().length > 1

  return {
    isProfileSwitchOn: isFlagOn,
    shouldRenderProfileSwitch: isFlagOn && hasOtherDeviceProfiles,
    canAddAccount: isFlagOn && !hasOtherDeviceProfiles,
    firstName: user?.name?.trim().split(' ')[0] ?? ''
  }
}
